/** Windows High Contrast repaints author colours; a SYSTEM colour survives. Selected vs not, for tabs. */
export const hcUnderlineSelected = 'forced-colors:[border-color:Highlight]';
/** Paint the other tab's underline out, or forced colours (and hover) mark both. */
export const hcUnderlineIdle = 'forced-colors:[border-color:Canvas]';
/**
 * For tabs marked by a filled pill rather than an underline. The others have no fill, so need nothing.
 * The pill opts out of forcing, or Chrome and Edge draw its label on a Canvas plate where HighlightText cannot be
 * read; opting out also drops the browser's Highlight focus outline and its shadow removal, so both are put back.
 */
export const hcFillSelected =
  'forced-colors:[background-color:Highlight] forced-colors:[color:HighlightText] forced-colors:[forced-color-adjust:none] forced-colors:focus-visible:[outline-color:Highlight] forced-colors:![box-shadow:none]';
